export default [
  // {
  //   title: '消息',
  //   icon: 'chat-o',
  //   path: '/message'
  // },
  {
    title: '工作台',
    icon: 'home-o',
    path: '/index'
  },
  {
    title: '我的',
    icon: 'contact-o',
    path: '/my'
  },
  // {
  //   title: '我的',
  //   icon: 'https://pic6.zhuanstatic.com/zhuanzh/764a3abf-a285-49b6-9f13-ec86278d9726.png',
  //   icon_active: 'https://pic6.zhuanstatic.com/zhuanzh/4b7c7f5c-32c1-4dff-9909-2fe40f2cbcaa.png',
  //   path: '/my'
  // }
]
